import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.08,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.animate-on-scroll').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <section id="app">
          <div className="animate-on-scroll">
            <AppSection />
          </div>
        </section>

        <section id="index">
          <div className="animate-on-scroll">
            <IndexSection />
          </div>
        </section>

        <section id="carousel">
          <div className="animate-on-scroll">
            <CarouselSection />
          </div>
        </section>

        <section id="contact">
          <div className="animate-on-scroll">
            <ContactSection />
          </div>
        </section>

        <section id="media">
          <div className="animate-on-scroll">
            <MediaSection />
          </div>
        </section>

        <section id="faq">
          <div className="animate-on-scroll">
            <FaqSection />
          </div>
        </section>

        <section id="cards">
          <div className="animate-on-scroll">
            <CardsSection />
          </div>
        </section>

        <section id="comments">
          <div className="animate-on-scroll">
            <CommentsSection />
          </div>
        </section>

        <section id="about">
          <div className="animate-on-scroll">
            <AboutSection />
          </div>
        </section>

        <section id="ranking">
          <div className="animate-on-scroll">
            <RankingSection />
          </div>
        </section>

        <section id="topics">
          <div className="animate-on-scroll">
            <TopicsSection />
          </div>
        </section>

        <section id="features">
          <div className="animate-on-scroll">
            <FeaturesSection />
          </div>
        </section>

        <section id="updates">
          <div className="animate-on-scroll">
            <UpdatesSection />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}